import { render } from "./companies-settings.vue?vue&type=template&id=2da8b4ed"
import script from "./companies-settings.vue?vue&type=script&lang=js"
export * from "./companies-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__